/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "laundry-31bb2220--sprite",
  "use": "laundry-31bb2220--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"laundry-31bb2220--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-5.424 1.592)\"><g transform=\"translate(12.4 2.5)\"><path d=\"M32.164,2.5H14.655A2.255,2.255,0,0,0,12.4,4.755V7.946H34.448V4.755A2.3,2.3,0,0,0,32.164,2.5ZM15.006,6.219a1,1,0,1,1,1-1A.987.987,0,0,1,15.006,6.219Zm3.192,0a1,1,0,1,1,1-1A1.006,1.006,0,0,1,18.2,6.219Z\" transform=\"translate(-12.4 -2.5)\" fill=\"currentColor\" /><path d=\"M12.4,45.883a2.255,2.255,0,0,0,2.255,2.255H32.164a2.255,2.255,0,0,0,2.255-2.255V27.7H12.4ZM23.409,30.569a7.349,7.349,0,1,1-7.349,7.349A7.354,7.354,0,0,1,23.409,30.569Z\" transform=\"translate(-12.4 -20.321)\" fill=\"currentColor\" /><path d=\"M36.068,54.436A5.768,5.768,0,1,0,30.3,48.668,5.761,5.761,0,0,0,36.068,54.436Zm0-9.984A4.188,4.188,0,0,1,40.226,48.2a.941.941,0,0,1-.7.322.977.977,0,0,1-.732-.351,1.383,1.383,0,0,0-1-.439,1.362,1.362,0,0,0-1.025.468.993.993,0,0,1-.7.322.977.977,0,0,1-.732-.351,1.383,1.383,0,0,0-1-.439,1.413,1.413,0,0,0-1.025.468.891.891,0,0,1-.7.322.994.994,0,0,1-.7-.322A4.188,4.188,0,0,1,36.068,44.452Z\" transform=\"translate(-25.059 -31.071)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
